import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LayoutDashboard, Sparkles, Tag, Users, Bookmark, BookOpen, File, Star, FileText, Layers, Share2, Building2, Send, ChevronRight, Plus, ChevronDown, Megaphone, Users2, UserCircle, Folder, Target, Forward } from "lucide-react";
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { openCreateVideoModal } from '../Store/uiSlice';


function NavLeft({ isOpen, onNavigate }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const isSidebarCollapsed = isOpen === false;
  const [zimzeeAICollapsed, setZimzeeAICollapsed] = useState(false)
  const [quickAccessCollapsed, setQuickAccessCollapsed] = useState(false)
  const [, setCreateDropdownOpen] = useState(false)

  const [zimzeeAIItems, setZimzeeAIItems] = useState([
    { name: 'Studio', icon: <Sparkles />, href: '/app/ads', current: false },
    { name: 'Marketing', icon: <Target />, href: '/app/marketing', current: false },
    { name: 'Autopilot', icon: <Send />, href: '/app/automation', current: false },
    { name: 'Brands', icon: <Building2 />, href: '/app/brands', current: false },
    { name: 'Audiences', icon: <Users />, href: '/app/audiences', current: false },
    { name: 'Characters', icon: <UserCircle />, href: '/app/characters', current: false },
    { name: 'Media Library', icon: <Folder />, href: '/app/assets-library', current: false },
  ]);

  const [generalItems, setGeneralItems] = useState([
    // { name: 'Dashboard', icon: <LayoutDashboard />, href: '/app/dashboard', current: false },
    { name: 'My Buckets', icon: <LayoutDashboard />, href: '/app/buckets', current: false },
  ]);

  const [quickAccessItems, setQuickAccessItems] = useState([
    { name: 'All Cards', icon: <Layers />, href: '/app/card', current: false },
    { name: 'Bookmarks', icon: <Bookmark />, href: '/app/bookmarks', current: false },
    { name: 'Kindle', icon: <BookOpen />, href: '/app/kindleList', count: 3, current: false },
    { name: 'Files', icon: <File />, href: '/app/files', current: false },
    { name: 'Tags', icon: <Tag />, href: '/app/tags', count: 12, current: false },
    { name: 'Starred', icon: <Star />, href: '/app/starred', current: false },
    { name: 'Cards with Notes', icon: <FileText />, href: '/app/cardwithnotes', current: false },
    { name: 'Shared with me', icon: <Share2 />, href: '/app/SharedWithMe', current: false },
    { name: 'What I Shared', icon: <Forward />, href: '/app/whatishared', current: false },
  ]);

  const [createOptions, ] = useState([
    {
      name: 'Image ads',
      icon: <Megaphone className="w-4 h-4" />,
      href: '/app/ads',
      category: null,
      state: { openVideoModal: true, type: 'image-ads' }
    },
    {
      name: 'Speaking Character',
      icon: <Users2 className="w-4 h-4" />,
      href: '/app/speaking-character',
      category: 'VIDEOS'
    },
    {
      name: 'Talking Head',
      icon: <UserCircle className="w-4 h-4" />,
      href: '/app/talking-head',
      category: 'VIDEOS'
    },
    // {
    //   name: 'Video Hook + Demo',
    //   icon: <Video className="w-4 h-4" />,
    //   href: '/app/speaking-character',
    //   category: 'VIDEOS'
    // },
    // {
    //   name: 'Wall of Text',
    //   icon: <Type className="w-4 h-4" />,
    //   href: '/app/speaking-character',
    //   category: 'VIDEOS'
    // },
    // {
    //   name: 'Slideshow',
    //   icon: <Presentation className="w-4 h-4" />,
    //   href: '/app/speaking-character',
    //   category: 'VIDEOS'
    // },
    // {
    //   name: 'Fast Cut Video',
    //   icon: <Scissors className="w-4 h-4" />,
    //   href: '/app/speaking-character',
    //   category: 'VIDEOS'
    // },
  ]);

  // const [navigation, setNavigation] = useState([
  //   { name: 'Dashboard', icon: <LayoutDashboard />, href: '/app/dashboard', current: false },
  //   { name: 'My Buckets', icon: <Archive />, href: '/app/buckets', current: true },
  //   { name: 'AI Studio', icon: <Sparkles />, href: '/app/ads', current: false },
  //   { name: 'Brands', icon: <Building2 />, href: '/app/brands', current: false },
  //   { name: 'Automations', icon: <Clock />, href: '/app/automation', current: false },
  //   { name: 'Audiences', icon: <Users />, href: '/app/audiences', current: false },
  //   { name: 'Bookmarks', icon: <Bookmark />, href: '/app/bookmarks', current: false },
  //   { name: 'Kindle', icon: <BookOpen />, href: '/app/kindleList', count: 3, current: false },
  //   { name: 'Files', icon: <File />, href: '/app/files', current: false },
  //   { name: 'Tags', icon: <Tag />, href: '/app/tags', count: 12, current: false },
  //   { name: 'Starred', icon: <Star />, href: '/app/starred', current: false },
  //   { name: 'Cards with Notes', icon: <FileText />, href: '/app/cardwithnotes', current: false },
  //   { name: 'All Cards', icon: <Layers />, href: '/app/Card', current: false },
  //   { name: 'Shared with me', icon: <Share2 />, href: '/app/SharedWithMe', current: false },
  //   { name: 'What I Shared', icon: <Send />, href: '/app/whatishared', current: false },
  // ]);

  // Refresh statistics on navigation; late responses must not restore an old route.
  useEffect(() => {
    const pathname = location.pathname;
    const controller = new AbortController();
    let active = true;
    const token = localStorage.getItem("token");
    const updateCurrentState = items => items.map(item => ({
      ...item,
      current: item.href?.toLowerCase() === pathname?.toLowerCase()
    }));
    setZimzeeAIItems(updateCurrentState);
    setGeneralItems(updateCurrentState);
    setQuickAccessItems(updateCurrentState);

    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + 'dashboard/stats',
          { headers: { Authorization: 'Bearer ' + token }, signal: controller.signal }
        );
        if (!active || !response?.data?.data) return;
        const stats = response.data.data;
        setGeneralItems(items => items.map(item => item.name === 'My Buckets'
          ? { ...item, count: stats.totalBuckets } : item));
        setQuickAccessItems(items => items.map(item => {
          if (item.name === 'Files') return { ...item, count: stats.totalFiles };
          if (item.name === 'All Cards') return { ...item, count: stats.totalCards };
          if (item.name === 'Tags') return { ...item, count: stats.totalTags };
          return item;
        }));
      } catch (error) {
        if (active) console.error("Error fetching data:", error);
      }
    };
    if (token) fetchBuckets();
    return () => {
      active = false;
      controller.abort();
    };
  }, [location]);

  const handleNavItemClick = (name, type) => {
    window.scrollTo(0, 0);
    if (type === 'general') {
      const updatedNavItems = generalItems.map((item) => {
        if (item.name === name) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      });
      setGeneralItems(updatedNavItems);
    } else if (type === 'zimzeeAI') {
      const updatedNavItems = zimzeeAIItems.map((item) => {
        if (item.name === name) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      });
      setZimzeeAIItems(updatedNavItems);
    } else {
      const updatedNavItems = quickAccessItems.map((item) => {
        if (item.name === name) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      });
      setQuickAccessItems(updatedNavItems);
    }
    onNavigate?.();
  };



  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  // Group create options by category
  const groupedCreateOptions = createOptions.reduce((acc, option) => {
    const category = option.category || 'GENERAL';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(option);
    return acc;
  }, {});

  return (
    <div className={`flex flex-grow flex-col`}>

      {/* Create Dropdown - Added at the top */}
      <div className="px-3 mb-4">
        <Menu as="div" className="relative">
          {({ open }) => (
            <>
              <Menu.Button
                title={isSidebarCollapsed ? "Create" : undefined}
                aria-label="Create"
                className={classNames(
                  open
                    ? 'relative font-semibold border border-orange-500/20 bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:border-orange-500/20 dark:text-orange-500'
                    : 'relative border border-transparent dark:hover:!bg-[#232323] hover:bg-gray-100',
                  `group mt-4 flex w-full items-center rounded-2xl ${isSidebarCollapsed ? 'justify-center px-0 py-2' : 'px-3 py-1.5'} text-sm font-medium focus:outline-none focus:ring-0 transition-colors`
                )}
              >
                <div className={classNames(
                  open
                    ? '!text-orange-600 dark:group-hover:text-[#FF8C00]'
                    : 'text-gray-500 group-hover:text-gray-500 dark:text-gray-400 dark:group-hover:text-white',
                  `${isSidebarCollapsed ? 'mr-0' : 'mr-2'} flex-shrink-0 w-4 h-4 flex items-center justify-center`
                )}>
                  <Plus className="w-[14px] h-[14px]" />
                </div>
                {!isSidebarCollapsed && (
                  <>
                    <span
                      className={classNames(
                        open
                          ? '!text-orange-600 dark:group-hover:text-[#FF8C00]'
                          : 'text-gray-600 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white',
                        'flex-1 text-left text-sm font-medium'
                      )}
                    >
                      Create
                    </span>
                    <ChevronDown
                      className={classNames(
                        open
                          ? '!text-orange-600 rotate-180'
                          : 'text-gray-400 group-hover:text-gray-600',
                        'h-4 w-4 transition-transform duration-200 flex-shrink-0'
                      )}
                    />
                  </>
                )}
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-[#111111] border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg z-50 py-2 overflow-hidden">
                  {Object.entries(groupedCreateOptions).map(([category, options]) => (
                    <div key={category}>
                      {category !== 'GENERAL' && (
                        <div className="px-3 py-1.5 text-sm font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                          {category}
                        </div>
                      )}
                      {options.map((option) => (
                        <Menu.Item key={option.name}>
                          {({ active }) => {
                            const isGlobalModalOption = ['Image ads'].includes(option.name);
                            if (isGlobalModalOption) {
                              return (
                                <button
                                  onClick={() => {
                                    dispatch(openCreateVideoModal({ type: 'image-ads' }));
                                    setCreateDropdownOpen(false);
                                    onNavigate?.();
                                  }}
                                  className={classNames(
                                    active
                                      ? "bg-orange-50 text-orange-600 border-orange-500/20 font-semibold dark:bg-orange-500/10 dark:text-orange-500 dark:border-orange-500/20"
                                      : "text-gray-600 dark:text-gray-300",
                                    "group flex w-full items-center !px-3 !py-1.5 text-sm font-medium focus:outline-none focus:ring-0 transition-colors dark:hover:!bg-[#292828] text-left"
                                  )}
                                >
                                  <div className="mr-2 flex-shrink-0 w-4 h-4 flex items-center justify-center text-gray-500 dark:text-gray-400 group-hover:text-orange-600 dark:group-hover:text-orange-500">
                                    {React.cloneElement(option.icon, {
                                      className: "w-[14px] h-[14px]",
                                      stroke: "currentColor",
                                      fill: "none",
                                      strokeWidth: 2
                                    })}
                                  </div>
                                  <span className="text-left text-sm">
                                    {option.name}
                                  </span>
                                </button>
                              );
                            }
                            return (
                              <Link
                                to={option.href}
                                state={option.state}
                                onClick={() => onNavigate?.()}
                                className={classNames(
                                  active
                                    ? "bg-orange-50 text-orange-600 border-orange-500/20 font-semibold dark:bg-orange-500/10 dark:text-orange-500 dark:border-orange-500/20"
                                    : "text-gray-600 dark:text-gray-300",
                                  "group flex w-full items-center !px-3 !py-1.5 text-sm font-medium focus:outline-none focus:ring-0 transition-colors dark:hover:!bg-[#292828]"
                                )}
                              >
                                <div className="mr-2 flex-shrink-0 w-4 h-4 flex items-center justify-center">
                                  {React.cloneElement(option.icon, {
                                    className: "w-[12px] h-[12px]",
                                    stroke: "currentColor",
                                    fill: "none",
                                    strokeWidth: 2
                                  })}
                                </div>
                                <span className="text-left text-sm">
                                  {option.name}
                                </span>
                              </Link>
                            );
                          }}
                        </Menu.Item>
                      ))}
                    </div>
                  ))}
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      </div>
      {/* REST OF THE NAVIGATION ITEMS - UNCHANGED */}
      <div className="flex flex-grow flex-col">
        <nav className="" aria-label="Sidebar">
          <div className="px-3">
            <div className="space-y-1">
              {generalItems.map((item) => (
                <Link
                  key={item.name}
                  to={item?.href}
                  onClick={() => handleNavItemClick(item.name, 'general')}
                  className={classNames(
                    item.current
                      ? 'relative font-semibold border border-orange-500/20 bg-orange-50 text-orange-600 transition-all duration-200 dark:bg-orange-500/10 dark:border-orange-500/20 dark:text-orange-500 dark:hover:!bg-orange-500/20'
                      :
                      'relative border border-transparent dark:hover:!bg-[#232323] hover:text-gray-900 hover:bg-gray-100',
                    'group flex w-full items-center rounded-2xl px-3 py-1.5 text-sm font-medium focus:outline-none focus:ring-0 !mb-0 !pb-0 !pt-0 !mt-0'
                  )}
                >
                  <p
                    className={classNames(
                      item.current
                        ?
                        '!text-inherit'
                        :
                        'text-gray-500 group-hover:text-gray-500 dark:text-gray-400 dark:group-hover:text-white',
                      'mr-2 flex-shrink-0 w-4 h-4 flex items-center justify-center'
                    )}
                  >
                    {React.cloneElement(item.icon, {
                      className: "w-[14px] h-[14px]",
                      stroke: "currentColor",
                      fill: "none",
                      strokeWidth: 2
                    })}
                  </p>
                  <span
                    className={classNames(
                      item.current
                        ?
                        '!text-inherit'
                        :
                        'text-gray-600 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white',
                      'relative menuNav text-sm'
                    )}
                  >
                    {item.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div className={isSidebarCollapsed ? "mt-4 px-3" : "mt-6 px-3"}>
            <button
              onClick={() => setZimzeeAICollapsed(!zimzeeAICollapsed)}
              title="Zimzee AI"
              aria-label="Toggle Zimzee AI section"
              aria-expanded={!zimzeeAICollapsed}
              className={`w-full flex items-center ${isSidebarCollapsed ? "justify-center px-0 mb-2" : "justify-between px-3 mb-3 text-sm"} font-semibold uppercase tracking-wider transition-colors dark:text-gray-600 dark:hover:text-gray-400 text-gray-400 hover:text-gray-600`}
            >
              {!isSidebarCollapsed && <span>ZIMZEE AI</span>}
              <ChevronRight className={`h-3.5 w-3.5 transition-transform duration-200 ${zimzeeAICollapsed ? "" : "rotate-90"}`} />
            </button>
            {!zimzeeAICollapsed && (
              <div className="space-y-1">
                {zimzeeAIItems.map((item) => (
                  <Link
                    key={item.name}
                    to={item?.href}
                    state={item.name === 'Marketing' ? { reset: Date.now() } : undefined}
                    onClick={() => handleNavItemClick(item.name, 'zimzeeAI')}
                    className={classNames(
                      item.current
                        ? 'relative font-semibold border border-orange-500/20 bg-orange-50 text-orange-600 transition-all duration-200 dark:bg-orange-500/10 dark:border-orange-500/20 dark:text-orange-500 dark:hover:!bg-orange-500/20'
                        :
                        'relative border border-transparent dark:hover:!bg-[#232323] hover:text-gray-900 hover:bg-gray-100',
                      'group flex w-full items-center rounded-2xl px-3 py-1.5 text-sm font-medium focus:outline-none focus:ring-0 !mb-0 !pb-0 !pt-0 !mt-0'
                    )}
                  >
                    <p
                      className={classNames(
                        item.current
                          ?
                          '!text-inherit'
                          :
                          'text-gray-500 group-hover:text-gray-500 dark:text-gray-400 dark:group-hover:text-white',
                        'mr-2 flex-shrink-0 w-4 h-4 flex items-center justify-center'
                      )}
                    >
                      {React.cloneElement(item.icon, {
                        className: "w-[14px] h-[14px]",
                        stroke: "currentColor",
                        fill: "none",
                        strokeWidth: 2
                      })}
                    </p>
                    <span
                      className={classNames(
                        item.current
                          ?
                          '!text-inherit'
                          :
                          'text-gray-600 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white',
                        'relative menuNav text-sm'
                      )}
                    >
                      {item.name}
                    </span>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <div className={isSidebarCollapsed ? "mt-4 px-3" : "mt-6 px-3"}>
            <button
              onClick={() => setQuickAccessCollapsed(!quickAccessCollapsed)}
              title="Quick Access"
              aria-label="Toggle Quick Access section"
              aria-expanded={!quickAccessCollapsed}
              className={`w-full flex items-center ${isSidebarCollapsed ? "justify-center px-0 mb-2" : "justify-between px-3 mb-3 text-sm"} font-semibold uppercase tracking-wider transition-colors dark:text-gray-600 dark:hover:text-gray-400 text-gray-400 hover:text-gray-600`}
            >
              {!isSidebarCollapsed && <span>QUICK ACCESS</span>}
              <ChevronRight className={`h-3.5 w-3.5 transition-transform duration-200 ${quickAccessCollapsed ? "" : "rotate-90"}`} />
            </button>
            {!quickAccessCollapsed && (
              <div className="space-y-1">
                {quickAccessItems?.map((item) => (
                  <Link
                    key={item.name}
                    to={item?.href}
                    onClick={() => handleNavItemClick(item.name, 'quickAccess')}
                    className={classNames(
                      item.current
                        ? 'relative font-semibold border border-orange-500/20 bg-orange-50 text-orange-600 transition-all duration-200 dark:bg-orange-500/10 dark:border-orange-500/20 dark:text-orange-500 dark:hover:!bg-orange-500/20'
                        :
                        'relative border border-transparent dark:hover:!bg-[#232323] hover:text-gray-900 hover:bg-gray-100',
                      'group flex w-full items-center rounded-2xl px-3 py-1.5 text-sm font-medium focus:outline-none focus:ring-0 !mb-0 !pb-0 !pt-0 !mt-0'
                    )}
                  >
                    <p
                      className={classNames(
                        item.current
                          ?
                          '!text-inherit'
                          :
                          'text-gray-500 group-hover:text-gray-500 dark:text-gray-400 dark:group-hover:text-white',
                        'mr-2 flex-shrink-0 w-4 h-4 flex items-center justify-center'
                      )}
                    >
                      {React.cloneElement(item.icon, {
                        className: "w-[14px] h-[14px]",
                        stroke: "currentColor",
                        fill: "none",
                        strokeWidth: 2
                      })}
                    </p>
                    <span
                      className={classNames(
                        item.current
                          ?
                          '!text-inherit'
                          :
                          'text-gray-600 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white',
                        'relative menuNav text-sm'
                      )}
                    >
                      {item.name}
                    </span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>
      </div>
    </div >
  )
}

export default NavLeft;
